import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckMotoService {
  private data = null;
  private url = environment.serviceApi;

  constructor(public http: Http) { }

  getChecksMoto(ordem = null) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmoto' + (ordem ? '/ordem/' + ordem : ''))
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getCheckMoto(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmoto/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getCheckMotoByUnidade(unidade_id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmoto/unidade/' + unidade_id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getCheckMotoByUsuario(usuario_id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmoto/usuario/' + usuario_id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getCheckMotoByRegiao(usuario_id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/checkmoto/regiao/' + usuario_id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaCheckMoto(data) {
    return new Promise((resolve, reject) => {
      this.http.post(this.url + '/checkmoto', {
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        check_moto_data: data.check_moto_data,
        check_moto_turno: data.check_moto_turno,
        check_moto_justificativa: data.check_moto_justificativa,
        profissional_id: data.profissional_id,
        veiculo_id: data.veiculo_id,
        check_moto_quilometragem: data.check_moto_quilometragem,
        check_moto_combustivel: data.check_moto_combustivel,
        check_moto_oleo_motor: data.check_moto_oleo_motor,
        check_moto_oleo_motor_obs: data.check_moto_oleo_motor_obs,
        check_moto_corrente: data.check_moto_corrente,
        check_moto_corrente_obs: data.check_moto_corrente_obs,
        check_moto_freio: data.check_moto_freio,
        check_moto_freio_obs: data.check_moto_freio_obs,
        check_moto_pneus: data.check_moto_pneus,
        check_moto_pneus_obs: data.check_moto_pneus_obs,
        check_moto_retrovisor_dir: data.check_moto_retrovisor_dir,
        check_moto_retrovisor_dir_obs: data.check_moto_retrovisor_dir_obs,
        check_moto_retrovisor_esq: data.check_moto_retrovisor_esq,
        check_moto_retrovisor_esq_obs: data.check_moto_retrovisor_esq_obs,
        check_moto_meia_luz: data.check_moto_meia_luz,
        check_moto_meia_luz_obs: data.check_moto_meia_luz_obs,
        check_moto_luz_baixa: data.check_moto_luz_baixa,
        check_moto_luz_baixa_obs: data.check_moto_luz_baixa_obs,
        check_moto_luz_alta: data.check_moto_luz_alta,
        check_moto_luz_alta_obs: data.check_moto_luz_alta_obs,
        check_moto_pisca_direito: data.check_moto_pisca_direito,
        check_moto_pisca_direito_obs: data.check_moto_pisca_direito_obs,
        check_moto_pisca_esquerdo: data.check_moto_pisca_esquerdo,
        check_moto_pisca_esquerdo_obs: data.check_moto_pisca_esquerdo_obs,
        check_moto_partida: data.check_moto_partida,
        check_moto_partida_obs: data.check_moto_partida_obs,
        check_moto_luz_freio: data.check_moto_luz_freio,
        check_moto_luz_freio_obs: data.check_moto_luz_freio_obs,
        check_moto_lanterna_tra: data.check_moto_lanterna_tra,
        check_moto_lanterna_tra_obs: data.check_moto_lanterna_tra_obs,
        check_moto_sirene: data.check_moto_sirene,
        check_moto_sirene_obs: data.check_moto_sirene_obs,
        check_moto_buzina: data.check_moto_buzina,
        check_moto_buzina_obs: data.check_moto_buzina_obs,
        check_moto_giroflex: data.check_moto_giroflex,
        check_moto_giroflex_obs: data.check_moto_giroflex_obs,
        check_moto_estrobo: data.check_moto_estrobo,
        check_moto_estrobo_obs: data.check_moto_estrobo_obs,
        check_moto_capacete: data.check_moto_capacete,
        check_moto_capacete_obs: data.check_moto_capacete_obs,
        check_moto_joelheira: data.check_moto_joelheira,
        check_moto_joelheira_obs: data.check_moto_joelheira_obs,
        check_moto_cotoveleira: data.check_moto_cotoveleira,
        check_moto_cotoveleira_obs: data.check_moto_cotoveleira_obs,
        check_moto_luvas: data.check_moto_luvas,
        check_moto_luvas_obs: data.check_moto_luvas_obs,
        check_moto_botas: data.check_moto_botas,
        check_moto_botas_obs: data.check_moto_botas_obs,
        check_moto_colete: data.check_moto_colete,
        check_moto_colete_obs: data.check_moto_colete_obs,
        check_moto_jaqueta: data.check_moto_jaqueta,
        check_moto_jaqueta_obs: data.check_moto_jaqueta_obs,
        check_moto_capa: data.check_moto_capa,
        check_moto_capa_obs: data.check_moto_capa_obs,
        check_moto_documento: data.check_moto_documento,
        check_moto_documento_obs: data.check_moto_documento_obs,
        check_moto_cartao_abastecimento: data.check_moto_cartao_abastecimento,
        check_moto_cartao_abastecimento_obs: data.check_moto_cartao_abastecimento_obs,
        check_moto_gps: data.check_moto_gps,
        check_moto_gps_obs: data.check_moto_gps_obs,
        check_moto_celular: data.check_moto_celular,
        check_moto_celular_obs: data.check_moto_celular_obs,
        check_moto_registro: data.check_moto_registro,
        check_moto_inicio: data.check_moto_inicio,
				check_moto_fim: data.check_moto_fim
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  editaCheckMoto(data) {
    return new Promise((resolve, reject) => {
      this.http.put(this.url + '/checkmoto/' + data.check_moto_id, {
        usuario_id: data.usuario_id,
        unidade_id: data.unidade_id,
        cliente_id: data.cliente_id,
        check_moto_data: data.check_moto_data,
        check_moto_turno: data.check_moto_turno,
        check_moto_justificativa: data.check_moto_justificativa,
        profissional_id: data.profissional_id,
        veiculo_id: data.veiculo_id,
        check_moto_quilometragem: data.check_moto_quilometragem,
        check_moto_combustivel: data.check_moto_combustivel,
        check_moto_oleo_motor: data.check_moto_oleo_motor,
        check_moto_oleo_motor_obs: data.check_moto_oleo_motor_obs,
        check_moto_corrente: data.check_moto_corrente,
        check_moto_corrente_obs: data.check_moto_corrente_obs,
        check_moto_freio: data.check_moto_freio,
        check_moto_freio_obs: data.check_moto_freio_obs,
        check_moto_pneus: data.check_moto_pneus,
        check_moto_pneus_obs: data.check_moto_pneus_obs,
        check_moto_retrovisor_dir: data.check_moto_retrovisor_dir,
        check_moto_retrovisor_dir_obs: data.check_moto_retrovisor_dir_obs,
        check_moto_retrovisor_esq: data.check_moto_retrovisor_esq,
        check_moto_retrovisor_esq_obs: data.check_moto_retrovisor_esq_obs,
        check_moto_meia_luz: data.check_moto_meia_luz,
        check_moto_meia_luz_obs: data.check_moto_meia_luz_obs,
        check_moto_luz_baixa: data.check_moto_luz_baixa,
        check_moto_luz_baixa_obs: data.check_moto_luz_baixa_obs,
        check_moto_luz_alta: data.check_moto_luz_alta,
        check_moto_luz_alta_obs: data.check_moto_luz_alta_obs,
        check_moto_pisca_direito: data.check_moto_pisca_direito,
        check_moto_pisca_direito_obs: data.check_moto_pisca_direito_obs,
        check_moto_pisca_esquerdo: data.check_moto_pisca_esquerdo,
        check_moto_pisca_esquerdo_obs: data.check_moto_pisca_esquerdo_obs,
        check_moto_partida: data.check_moto_partida,
        check_moto_partida_obs: data.check_moto_partida_obs,
        check_moto_luz_freio: data.check_moto_luz_freio,
        check_moto_luz_freio_obs: data.check_moto_luz_freio_obs,
        check_moto_lanterna_tra: data.check_moto_lanterna_tra,
        check_moto_lanterna_tra_obs: data.check_moto_lanterna_tra_obs,
        check_moto_sirene: data.check_moto_sirene,
        check_moto_sirene_obs: data.check_moto_sirene_obs,
        check_moto_buzina: data.check_moto_buzina,
        check_moto_buzina_obs: data.check_moto_buzina_obs,
        check_moto_giroflex: data.check_moto_giroflex,
        check_moto_giroflex_obs: data.check_moto_giroflex_obs,
        check_moto_estrobo: data.check_moto_estrobo,
        check_moto_estrobo_obs: data.check_moto_estrobo_obs,
        check_moto_capacete: data.check_moto_capacete,
        check_moto_capacete_obs: data.check_moto_capacete_obs,
        check_moto_joelheira: data.check_moto_joelheira,
        check_moto_joelheira_obs: data.check_moto_joelheira_obs,
        check_moto_cotoveleira: data.check_moto_cotoveleira,
        check_moto_cotoveleira_obs: data.check_moto_cotoveleira_obs,
        check_moto_luvas: data.check_moto_luvas,
        check_moto_luvas_obs: data.check_moto_luvas_obs,
        check_moto_botas: data.check_moto_botas,
        check_moto_botas_obs: data.check_moto_botas_obs,
        check_moto_colete: data.check_moto_colete,
        check_moto_colete_obs: data.check_moto_colete_obs,
        check_moto_jaqueta: data.check_moto_jaqueta,
        check_moto_jaqueta_obs: data.check_moto_jaqueta_obs,
        check_moto_capa: data.check_moto_capa,
        check_moto_capa_obs: data.check_moto_capa_obs,
        check_moto_documento: data.check_moto_documento,
        check_moto_documento_obs: data.check_moto_documento_obs,
        check_moto_cartao_abastecimento: data.check_moto_cartao_abastecimento,
        check_moto_cartao_abastecimento_obs: data.check_moto_cartao_abastecimento_obs,
        check_moto_gps: data.check_moto_gps,
        check_moto_gps_obs: data.check_moto_gps_obs,
        check_moto_celular: data.check_moto_celular,
        check_moto_celular_obs: data.check_moto_celular_obs,
        check_moto_registro: data.check_moto_registro,
        check_moto_inicio: data.check_moto_inicio,
				check_moto_fim: data.check_moto_fim
      })
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  apagaCheckMoto(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/checkmoto/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
  apagaCheckMotoAdmin(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.url + '/checkmoto/admin/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }
}
